module.exports = __webpack_public_path__ + "static/media/brytephoto.92098508.mp4";